import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { withModal } from "../../contexts/ModalContext";
import { openPaymentArrangementModal } from "../../services/modalService";
import Paragraph from "../atoms/Paragraph";
import { useSelector } from "react-redux";
import RadioGroup from "../atoms/RadioGroup";
import { color } from "../templates/ui";
import Button from "../atoms/Button";
import ChevronRight from "../atoms/icons/ChevronRight";
import { fetchDossiersListCriteria } from "../../services/dossierService";
import { moneyFormat } from "../../services/currencyService";
import RequestNotAvailable from "../molecules/RequestNotAvailable";
const StyledChevronRight = styled(ChevronRight) `
  width: 6px;
  height: 12px;
  fill: ${color.body.base};
  margin-right: 10px;
`;
const StyledParagraph = styled(Paragraph) `
  margin-bottom: 20px;
`;
const StyledRadioGroup = styled(RadioGroup) `
  margin-bottom: 20px;
`;
const StyledLoadingContainer = styled.div `
  position: relative;
  width: 3.5rem;
  height: 0.875rem;

  &:after {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0.75rem;
    height: 0.75rem;
    background-image: url("/img/indicator.png");
    margin-top: -0.375rem;
    margin-left: -0.375rem;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 1;
    animation: button-indicator-rotations 600ms linear infinite;
    transition: all 120ms ease-in-out 0ms, visibility 0ms ease-in-out 120ms;
    content: "";
    filter: brightness(0);
  }

  @keyframes button-indicator-rotations {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
const Badge = styled.span `
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 400;
  gap: 0.25rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background-color: transparent;
  color: inherit;
`;
const FooterContentContainer = styled.div `
  background: ${color.gray.lightest};
  padding: 20px 30px;
  margin: 0 -30px -30px -30px;
  z-index: 3;
`;
const SelectDossierTypeModal = ({ showModal, defaultValue, totalBalance: defaultTotalBalance, minimumMonthlyPayment: defaultMinimumMonthlyPayment, }) => {
    const [selectedValue, setSelectedValue] = useState(defaultValue);
    const { t } = useTranslation(["common", "dossier"]);
    const { dossier, settings } = useSelector((state) => state.data);
    const [totalBalance, setTotalBalance] = useState(defaultTotalBalance);
    const [minimumMonthlyPayment, setMinimumMonthlyPayment] = useState(defaultMinimumMonthlyPayment);
    const forMultipleDossiers = selectedValue === "all";
    const handleSelection = () => {
        const currentMinimumMonthlyPayment = forMultipleDossiers
            ? minimumMonthlyPayment
            : (settings.payment_plan_request_minimum_monthly_payment || 0);
        openPaymentArrangementModal(showModal, null, forMultipleDossiers, forMultipleDossiers ? totalBalance : dossier.balance, currentMinimumMonthlyPayment);
    };
    useEffect(() => {
        if (!defaultTotalBalance && !defaultMinimumMonthlyPayment) {
            fetchDossiersListCriteria()
                .then(data => {
                setMinimumMonthlyPayment(data.minimum_monthly_payment_multiple_dossiers);
                setTotalBalance(data.total_balance);
            })
                .catch(() => {
                setMinimumMonthlyPayment(null);
                setTotalBalance(null);
            });
        }
    }, []);
    if (!dossier.canRequestPaymentPlan) {
        return React.createElement(RequestNotAvailable, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledParagraph, null, t("dossier:arrangement.dossiers_explanation")),
        React.createElement(StyledRadioGroup, { name: "dossier-type", selectedValue: selectedValue, onChange: setSelectedValue, options: [
                {
                    id: "current",
                    title: (React.createElement(React.Fragment, null,
                        t("dossier:arrangement.current_dossier.title"),
                        React.createElement(Badge, null,
                            t("dossier:arrangement.outstanding"),
                            ":",
                            " ",
                            React.createElement("b", null, moneyFormat(dossier.balance))))),
                    description: t("dossier:arrangement.current_dossier.description"),
                },
                {
                    id: "all",
                    title: (React.createElement(React.Fragment, null,
                        t("dossier:arrangement.all_dossiers.title"),
                        React.createElement(Badge, null,
                            t("dossier:arrangement.outstanding"),
                            ":",
                            totalBalance ? React.createElement("b", null, moneyFormat(totalBalance)) : React.createElement(StyledLoadingContainer, null)))),
                    description: t("dossier:arrangement.all_dossiers.description"),
                    disabled: !totalBalance,
                },
            ] }),
        React.createElement(FooterContentContainer, null,
            React.createElement(Button, { type: "submit", tertiary: true, largeFont: true, bold: true, wide: true, reversed: true, onClick: handleSelection, icon: React.createElement(StyledChevronRight, null) }, t("common:generic.next")))));
};
export default withModal(SelectDossierTypeModal);
